import Channel from '@/Enums/Channel.enum';
import ChannelId from '@/Enums/ChannelId.enum';

export const pendingCaseHandler = reportType => (state, action) => {
  const requestIdVariableName = `${reportType}RequestId`;
  state[requestIdVariableName] = action.meta.requestId;
};

export const rejectedCaseHandler =
  (reportType, resetStateValue = null) =>
  (state, action) => {
    console.error(action.error);
    const requestIdVariableName = `${reportType}RequestId`;
    if (state[requestIdVariableName] === action.meta.requestId) {
      state[requestIdVariableName] = resetStateValue;
      action.payload?.onReject?.();
    }
  };

export const fulfilledCaseHandler = reportType => (state, action) => {
  const dataVariableName = reportType;
  const requestIdVariableName = `${dataVariableName}RequestId`;
  if (state[requestIdVariableName] === action.meta.requestId) {
    state[requestIdVariableName] = null;
    if (action.payload.data && action.payload.meta) {
      state[dataVariableName] = action.payload.data;
      state.total = action.payload.meta.total;
      return;
    }
    state[dataVariableName] = action.payload;
  }
};

export const transformProductsObject = data => {
  if (Array.isArray(data)) {
    return Object.fromEntries(data.map(({ channelName, products }) => [channelName, products ?? []]));
  }

  const transformedObj = {};
  Object.keys(data).forEach(key => {
    transformedObj[key] = data[key].products || data[key] || [];
  });
  return transformedObj;
};

export const splitProductsByChannel = products => {
  const Google = [];
  const Amazon = [];

  products.forEach(product => {
    if (product.channel.id === ChannelId.Google) {
      Google.push(product);
    } else if (product.channel.id === ChannelId.Amazon) {
      Amazon.push(product);
    }
  });
  return { [Channel.Google]: Google, [Channel.Amazon]: Amazon };
};
